<template>
  <a-form ref='form' :model='search' :style="{'marginBottom':'25px'}" :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
    <a-form-item class='mb15' label="关键字" name='sale_cat_name'>
      <a-input v-model:value="search.sale_cat_name" :style="{width:'300px'}" placeholder="请输入销售区名称" />
    </a-form-item>
    <a-form-item>
      <a-button type="primary" htmlType='submit'>搜索</a-button>
    </a-form-item>
  </a-form>
  <a-table :pagination='false' :loading='listLoading' bordered  :columns='columns' :data-source='data'>
    <template v-slot:action="{ record }">
     <a-button type="primary" @click='select(record)' v-if='!checkout' :ghost="!record.select">{{!record.select ? "选择":"已选择"}}</a-button>
      <a-button type="primary" @click='checkBnt(record)' :ghost="!record.select" v-else >{{!record.select ? "选择":"已选择"}}</a-button>
    </template>
  </a-table>
  <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" />
   <div class="s_flex_center m-t-10" v-if='checkout'>
    <a-button type="primary" @click='confirm'>确定</a-button>
  </div>
</template>

<script>
  import { ref, onMounted, inject, reactive, toRefs} from "vue";
  import { message } from "ant-design-vue";
  import { getDealerSaleCat } from "@/api/dealer";
  import { iscode } from "@/utils/app";
  // 初始化默认筛选项数值
  let defSearch = {
  page: 1,
  limit: 7,
  sale_cat_name: "",
  };
  export default {
    name: "selectDealerArea",
    components: {},
    props: {
      levelid: Number,
      selectList:{
        type:Array
      },
      
      checkout:{
        type:Boolean,
        defalut(){
          return false
        }
      }
    }, 
    setup(props, { emit }) {
      // // 初始化 分页信息和筛选项信息
      let search = ref({ ...defSearch });
      // 列表数据和列头配置
      let data = ref([]);
      const state = reactive({
        listLoading: false,
        time: [],
        total: 1,
        selectedRowKeys: [],
        selectList:[],
      });
      let columns = [
     {
    title: "销售大区",
    dataIndex: "sale_cat_name",
    key: "sale_cat_name",
  },
  {
    title: "经销商数量",
    dataIndex: "dealer_count",
    key: "dealer_count",
  },
  {
    title: "备注",
    dataIndex: "remark",
    key: "remark",
    width:250
  },
  {
    title: "创建时间",
    dataIndex: "created_at",
    key: "created_at",
  },
  {
    title: "最后更新时间",
    dataIndex: "updated_at",
    key: "updated_at",
  },
  {
    title: "操作",
    key: "action",
    slots: { customRender: "action" },
  },
      ];
      const $router = inject('$router')
      const $Modal = inject('$Modal')
      // 页面筛选项搜索
      const pageSearchChange = () => {
        search.value = { ...search.value, page: 1 };
       initData(search.value);
      };
      // 分页当前页切换
      const pageCurrentChange = (page, pageSize) => {
        search.value.page = page;
        initData(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData(search.value);
      };
      const select = (e) => {
        data.value.map(item => item.select = false)
          if(e!=0){
          e.select = !e.select
          }
          emit("select", e);
      }
         //多选
      const checkBnt = (e) => {
        if (!e.select) {
          state.selectList.push(e);
        } else {
          var index = 0;
          state.selectList.forEach((v, k) => {
              if (v.id == e.id) {
                index = k;
              }
            });
          state.selectList.splice(index, 1);
        }
        e.select = !e.select
      }
      //多选确认
      const confirm = () =>{ 
        emit("select",state.selectList);
      }
      const initData = async (values) => {
        state.listLoading = true;
        try {
          let res = await getDealerSaleCat(values).then(res => res.data);
          state.listLoading = false;
          if (iscode(res)) {
            data.value = res.data.data;
            state.total = res.data.total;
            if(state.selectList || state.selectList.length > 0){
              data.value.forEach(i=>{
                if( state.selectList.find(v=>{
                  return  i.id==v.id
                })){
                  i.select=true
                }
              })
            }
          } else {
            message.error(res.msg);
          }
        } catch (e) {
          state.listLoading = false;
        }
      };
      

      onMounted(() => {
         if(props.selectList){
          state.selectList = JSON.parse(JSON.stringify(props.selectList))
        }
        search.value.level_id = props.levelid == undefined ? '' : props.levelid
        initData(search.value)
      });
      return {
        ...toRefs(state),
        search,
        data,
        columns,
        pageSearchChange,
        pageCurrentChange,
        pageSizeChange,
        checkBnt,
        confirm,
        select
      };
    },
  };
</script>